import { createFileRoute } from "@tanstack/react-router";
import { LoadingScreen } from "@/components/ui/loading-screen";
import Users from "@/features/users";

export const Route = createFileRoute("/_authenticated/users/")({
  loader: () => new Promise((resolve) => setTimeout(resolve, 5000)),
  wrapInSuspense: true,
  pendingComponent: () => <LoadingScreen text="Loading..." />,
  component: Users,
});
